import { RouteObject } from 'react-router-dom'
import EstruturacaoReservaPage from '@/pages/reservas/estruturacao/EstruturacaoReservaPage'
import EstruturacaoPage from '@/pages/estruturacao/EstruturacaoPage'
import { SomenteBackoffice } from '../SomenteBackoffice'

/**
 * Rotas do A09 (Onda 4) — workspace de estruturação em 5 etapas.
 *
 * ATENÇÃO (integração): `path: 'estruturacao'` também está registrado diretamente em
 * `router/index.tsx` (registro anterior ao mecanismo de rotas por agente; o A09 não
 * pode editar aquele arquivo). Com os dois registros, o do index.tsx vence (vem
 * primeiro) — na integração o coordenador remove o registro antigo de lá: o elemento
 * daqui cobre as DUAS personas sem perder a página do back-office.
 */
const rotasA09: RouteObject[] = [
  { path: 'reservas/:id/estruturacao', element: <EstruturacaoReservaPage /> },
  // 23/10: a lista `/estruturacao` é só do back-office — o consultor (que tinha a lista
  // das próprias reservas) volta ao dashboard; o workspace por reserva acima segue dele.
  {
    path: 'estruturacao',
    element: (
      <SomenteBackoffice>
        <EstruturacaoPage />
      </SomenteBackoffice>
    ),
  },
]

export default rotasA09
